export type Nullable<T> = T | null | undefined;